import LabelsList from './LabelsList';

export default LabelsList;
